import styled from "styled-components";

export const PointPaidPopupWrapper = styled.div`
  width: 1000px;
  padding: 40px 25px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  position: absolute;
  z-index: 800;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 4px 0px #00000040;

  > .button-group {
    display: flex;
    gap: 5px;
  }
`;

export const PremiumPointPaidPopupWrapper = styled(PointPaidPopupWrapper)`
  width: 600px;
`;

export const PointPaidHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  > .right {
    display: flex;
    align-items: center;
    gap: 20px;

    > .info {
      font-family: Pretendard;
      font-weight: 700;
      font-size: 12px;
      color: #b10003;
    }

    > img {
      cursor: pointer;
    }
  }
`;

export const PointPaidHeaderInput = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  > .name {
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 500;
  }

  > .input {
    width: 30px;
    height: 14px;
    border-radius: 2.096px;
    border: 0.524px solid var(--Black-200, #b7b7b7);
    background: #fff;
    padding: 4px 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    > input {
      width: 100%;
      height: 100%;
      padding: 0;
      border: none;
      outline: none;
      text-align: center;
      font-family: Pretendard;
      font-size: 11px;
      font-weight: 500;
    }
  }
`;

export const PointPaidTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  margin-top: 20px;

  .rank {
    width: 7%;
  }

  .value {
    width: 30%;
  }

  .nickname {
    width: 25%;
  }

  .button {
    width: 15%;
  }
`;

export const PointPaidTableListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  height: 460px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
`;

export const PointPaidSelectWrapper = styled.div`
  position: absolute;
  top: 21px;
  left: -5px;
  width: 100%;
  background: #fff;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 5px;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;
  border: 1px solid #d9d9d9;

  > .item {
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    &.active {
      background: #6436e7;
      color: #fff;
    }
  }
`;

export const PointPaidTableItemWrapper = styled.div`
  width: calc(100% - 30px);
  display: flex;
  flex-direction: row;
  padding: 0 15px;
  gap: 25px;
  height: 40px;
  align-items: center;
  border-radius: 11.466px;
  background: #ecf0f3;
  flex-shrink: 0;

  > .rank {
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 11.466px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .unit {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    width: 40px;
    text-align: center;
  }

  > .nickname.active {
    background: #373636;
  }

  > .nickname {
    cursor: pointer;
    border-radius: 5.733px;
    background: #d9d9d9;
    height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 11.466px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const PointPaidItemPrize = styled.div`
  width: 30%;
  height: 14px;
  border-radius: 2.096px;
  border: 0.524px solid var(--Black-200, #b7b7b7);
  background: #fff;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  > input {
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    outline: none;
    text-align: center;
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  > .value {
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 5px;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    cursor: default;
    background: rgba(239, 239, 239, 0.3);
    width: 100%;
    height: 100%;
    text-align: center;
    color: rgb(84, 84, 84);

    &.edit {
      background: #fff;
      color: #121212;
      cursor: pointer;
    }
  }
`;

export const PointPaidItemSubPrizeWrapper = styled.div`
  padding: 0 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  color: #121212;
  text-align: center;
  font-family: Pretendard;
  font-size: 11.466px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  > .sub-prize-button {
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

export const PointPaidItemButton = styled.div`
  width: 15%;
  height: 23px;
  display: flex;
  justify-content: center;
  cursor: pointer;

  > .button {
    width: 50px;
    height: 23px;
    border-radius: 5.73px;
    background: #6436e7;
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    line-height: 23px;
    text-align: center;
    color: #fff;
  }

  > .refresh {
    width: 23px;
    height: 23px;
    background: #d9d9d9;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1px;

    > img {
      width: 14px;
      height: 14px;
    }
  }
`;

export const PointPaidButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const PointPaidButton = styled.div<{ background?: string }>`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  border-radius: 8px;
  background: ${(p) => (p.background ? p.background : "#6436e7")};
  height: 48px;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
  cursor: pointer;
`;

export const PointPaidTableHeader = styled.div`
  width: calc(100% - 30px);
  display: flex;
  flex-direction: row;
  padding: 0 15px;
  gap: 25px;

  > .item {
    color: #121212;
    font-family: Pretendard;
    font-size: 11.466px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }

  > .item.a {
    width: 10%;
  }

  > .item.b {
    width: 30%;
  }

  > .item.c {
    width: 25%;
  }

  > .item.d {
    width: 15%;
  }
`;

export const TournamentMemberPopupWrapper = styled.div`
  position: absolute;
  z-index: 1001;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 514px;
  height: 366px;
  box-sizing: border-box;
  padding: 40px 15px 23.5px 15px;
  flex-direction: column;
  border-radius: 12px;
  background: #fff;

  > .header {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 600;
    text-align: left;
  }

  > .main-wrapper {
    position: relative;
    padding-top: 12px;

    > .list-wrapper {
      height: 180px;
      padding: 10px 15px 10px 15px;
      border-radius: 15px;
      background: #e5e5e5;
      display: flex;
      flex-direction: column;
      gap: 7px;
      scrollbar-width: none;
      overflow-y: auto;

      > .list {
        height: 37px;
        box-sizing: border-box;
        padding: 5px 16px 5px 16px;
        border-radius: 14.71px;
        background: #ffffff;
        font-family: Pretendard;
        font-size: 14.67px;
        font-weight: 600;
        line-height: 27px;
      }
    }

    > .button-group {
      display: flex;
      gap: 20px;
      position: absolute;
      top: 240px;

      > .button {
        width: 238px;
        height: 48px;
        border-radius: 8px;
        line-height: 48px;
        font-family: Pretendard;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        cursor: pointer;
        color: #6436e7;

        &.purple {
          color: #fff;
          background: #7f25fb;
        }
      }
    }
  }
`;
